import React, { useEffect } from "react";
import InputBase from "@mui/material/InputBase";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import "./searchBar.scss";
import { useDispatch, useSelector } from "react-redux";
import { updateType } from "../../../redux/validation/actions";
import { InputLabel, MenuItem } from "@mui/material";
import { action } from "../../../constants/action";
import { getDrugProducts } from "../../../redux/investigation/actions";
export default function SearchBar({
  onSearch,
  diasableBatchOptions,
  searchText,
  drugType,
  setDrugType,
  setSearchText,
}) {
  const dispatch = useDispatch();
  const type = useSelector((state) => state?.validation?.type);
  const drugProducts = useSelector(
    (state) => state?.investigation?.drugProducts
  );
  useEffect(() => {
    dispatch(updateType("project"));
    dispatch(getDrugProducts()); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log("", type);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);

  useEffect(() => {
    document.getElementById("searchInput").value = "";
  }, [type]);

  const handleChange = (event) => {
    dispatch(updateType(event.target.value));
    setSearchText("");
  };
  return (
    <div className="search-container">
      <FormControl fullWidth size="small">
        <InputLabel id="drug-product-label">Product</InputLabel>
        <Select
          labelId="drug-product-label"
          id="drug-product-label"
          value={drugType}
          label="Product"
          onChange={(event) => setDrugType(event.target.value)}
          className="select-box"
        >
          {drugProducts?.map((product, index) => (
            <MenuItem key={index} value={product?.name}>
              {product.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {!diasableBatchOptions && (
        <div>
          <FormControl size="small" style={{ paddingLeft: "10px" }}>
            <Select
              className="input-select"
              labelId="demo-simple-select-autowidth-label"
              id="demo-simple-select-autowidth"
              value={type}
              onChange={handleChange}
              autoWidth
              disabled={diasableBatchOptions}
            >
              <MenuItem value="project">{action.UNIT_PROCEDURE}</MenuItem>
              <MenuItem value="batch">{action.BATCH}</MenuItem>
            </Select>
          </FormControl>
        </div>
      )}
      <div className="search m-0">
        {/* <div className="search-wrapper">
          <SearchIcon />
        </div> */}
        <InputBase
          id="searchInput"
          className="input-style"
          value={searchText}
          placeholder={action.SEARCH}
          inputProps={{ "aria-label": "search" }}
          onChange={(event) => onSearch(event.target.value, type)}
        />
      </div>
    </div>
  );
}
